import { createContext, useContext } from 'react';

// Ring diameter for StatRings sharing one fitted row; null keeps the fixed 80px wrapping layout.
const StatRingSizeContext = createContext<number | null>(null);

export const StatRingSizeProvider = StatRingSizeContext.Provider;

export function useStatRingFitSize(): number | null {
    return useContext(StatRingSizeContext);
}

// A fitted ring shares the row equally and may narrow below its label; a fixed one wraps at 110px.
export function statRingSlotClass(fitted: boolean): string {
    return `flex flex-col items-center gap-2 flex-1 ${fitted ? 'min-w-0' : 'min-w-[110px]'}`;
}
